import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";
import { DeviceAssignment } from "../models";

export const useUpdateBulkDeviceAssignments = ({
    companyId,
    locationId,
    onSuccess,
    onError,
}: {
    companyId: string;
    locationId: string;
    onSuccess?: () => void;
    onError?: (err: any, key: string) => void;
}) => {
    const {
        trigger: triggerUpdateBulkDeviceAssignments,
        isMutating: isLoadingUpdateBulkDeviceAssignments,
    } = useSWRMutation(
        `/api/device-management/v1/companies/${companyId}/locations/${locationId}/deviceAssignments/assign-bulk`,
        (
            url: string,
            {
                arg,
            }: {
                arg: DeviceAssignment[];
            }
        ) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.PUT,
                    body: JSON.stringify(arg),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerUpdateBulkDeviceAssignments,
        isLoadingUpdateBulkDeviceAssignments,
    };
};
